export function ChessLogo({ size = 36, className = "" }) {
  const cells = [];
  const n = 4;
  const s = size / n;
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      const dark = (r + c) % 2 === 0;
      cells.push(
        <rect
          key={`${r}-${c}`}
          x={c * s}
          y={r * s}
          width={s}
          height={s}
          fill={dark ? "#0F172A" : "#F8FAFC"}
        />
      );
    }
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      style={{ borderRadius: 8, overflow: "hidden", boxShadow: "0 0 0 2px hsl(var(--saffron))" }}
      aria-label="DNZD chessboard logo"
    >
      {cells}
    </svg>
  );
}
